var CitiesDataTestidEnum = /* @__PURE__ */ ((CitiesDataTestidEnum2) => {
  CitiesDataTestidEnum2["CITIES_FILTER_STATE_SELECT"] = "cities-filter--state-select";
  CitiesDataTestidEnum2["CITIES_FILTER_CITY_SELECT"] = "cities-filter--city-select";
  CitiesDataTestidEnum2["CITIES_FILTER_SEARCH_BUTTON"] = "cities-filter--search-button";
  CitiesDataTestidEnum2["CITY_MOCK_BRANCH_LIST_ITEM"] = "city--mock-branch-list-item";
  CitiesDataTestidEnum2["CITY_BRANCH_LIST_SHOW_MORE_BRANCHES"] = "city-branch-list--show-more-branches";
  CitiesDataTestidEnum2["CITY_BRANCH_PROFILE_HEADER"] = "city-branch-profile--header";
  CitiesDataTestidEnum2["CITY_BRANCH_PROFILE_ADDRESS"] = "city-branch-profile--address";
  CitiesDataTestidEnum2["CITY_BRANCH_PROFILE_CONTACT"] = "city-branch-profile--contact";
  CitiesDataTestidEnum2["CITY_BRANCH_PROFILE_ASIDE_CARD"] = "city-branch-profile--aside-card";
  return CitiesDataTestidEnum2;
})(CitiesDataTestidEnum || {});
export {
  CitiesDataTestidEnum
};
